import React from "react";
import { Container } from "@dyerlabs/design-system-web-components";

export interface FooterProps {}

const Footer: React.FC<FooterProps> = () => (
  <footer className="text-center">
    <Container>Copyright © 2026</Container>
  </footer>
);

export default Footer;
